import React from 'react'
import { Select, List } from 'antd'
import {Link} from 'react-router-dom'
import i18n from '../../i18n'

const links = [
  {key: 'changeLanguage'},
]

export default class Settings extends React.Component {
  state={}
  componentDidMount() {
  }
  changeLanguage=value=>{
    i18n.changeLanguage(value)
  }
  renderChangeLanguage() {
    const {t} = this.props
    const {language} = i18n
    return (
      <div className="w-100">
        {t(`settings:changeLanguage`)}
        <div className="float-right">
          <Select defaultValue={language||'en'} onChange={this.changeLanguage}>
            <Select.Option value="en">EN</Select.Option>
            <Select.Option value="my">MY</Select.Option>
          </Select>
        </div>
      </div>
    )
  }
  renderItem=e=>{
    const {t} = this.props
    const {key} = e
    if (key==='changeLanguage') {
      return (
        <List.Item>
          {this.renderChangeLanguage()}
        </List.Item>
      )
    }
    return (
      <List.Item>
        <Link to={`settings/${key}`}>
          {t(`settings:${key}`)}
        </Link>
      </List.Item>
    )
  }
  render() {
    const {t} = this.props
    return (
      <div>
        <h1>{t('key:settings')}</h1>
        <div className="main-content">
          <List
            bordered
            dataSource={links}
            renderItem={this.renderItem}
          />
        </div>
      </div>
    )
  }
}
